var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerOfAttorney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#2df788"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPowerofAttorney)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.6274,
    y: 16.6965,
    width: 6.25985,
    height: 9.625,
    transform: "rotate(45 29.6274 16.6965)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7295,
    y: 24.094,
    width: 12.7513,
    height: 3.84869,
    transform: "rotate(45 32.7295 24.094)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.377,
    y: 14.9465,
    width: 6.25985,
    height: 2.29078,
    transform: "rotate(45 31.377 14.9465)",
    fill: "#e2d1fa"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.627,
    y: 23.6965,
    width: 6.25985,
    height: 2.29078,
    transform: "rotate(45 22.627 23.6965)",
    fill: "#e2d1fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7203 32.3399L33.3903 24.0099L34.7903 22.6099L36.4003 20.9999C37.1003 20.2999 37.1003 19.1799 36.4003 18.5499L32.4103 14.5599C31.7803 13.9299 30.5903 13.9299 29.9603 14.5599L21.6303 22.7499L20.0203 24.3599C19.6703 24.7099 19.5303 25.1299 19.5303 25.6199C19.5303 26.1099 19.7403 26.5299 20.0203 26.8799L24.0103 30.8699C24.3603 31.2199 24.7803 31.3599 25.2703 31.3599C25.7603 31.3599 26.1803 31.2199 26.5303 30.8699L29.4703 27.9299L37.8003 36.1899C38.2203 36.6099 38.8503 36.8199 39.4803 36.8199C39.5503 36.8199 39.6203 36.8199 39.6903 36.8199C40.3203 36.7499 40.9503 36.4699 41.4403 35.9799C41.9303 35.4899 42.2103 34.8599 42.2803 34.2299C42.4203 33.4599 42.1403 32.8299 41.7203 32.3399ZM27.3703 27.0199L23.8703 23.5199L29.0503 18.3399L32.5503 21.8399L27.3703 27.0199ZM34.6503 19.7399L34.0203 20.3699L30.5203 16.8699L31.1503 16.2399L34.6503 19.7399ZM21.7703 25.6199L22.4003 24.9899L25.9003 28.4899L25.2703 29.1199L21.7703 25.6199ZM39.9703 34.5099C39.8303 34.6499 39.6203 34.7199 39.4803 34.7899C39.4103 34.7899 39.3403 34.7899 39.2703 34.7199L31.0103 26.3899L31.9203 25.4799L40.2503 33.8099C40.3203 33.8799 40.3203 33.9499 40.3203 34.0199C40.2503 34.1599 40.1803 34.3699 39.9703 34.5099Z",
    fill: "#090927"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1003 39.6198H29.4003V38.9198C29.4003 38.1498 28.7703 37.5198 28.0003 37.5198H16.8003C16.0303 37.5198 15.4003 38.1498 15.4003 38.9198V39.6198H14.7003C13.9303 39.6198 13.3003 40.2498 13.3003 41.0198C13.3003 41.7898 13.9303 42.4198 14.7003 42.4198H30.1003C30.8703 42.4198 31.5003 41.7898 31.5003 41.0198C31.5003 40.2498 30.8703 39.6198 30.1003 39.6198Z",
    fill: "#090927"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPowerofAttorney"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.05,
    height: 28.42,
    fill: "white",
    transform: "translate(13.3003 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOfAttorney);
export default __webpack_public_path__ + "static/media/power-of-attorney.9186dd9345163ac47820afa9fce7ea94.svg";
export { ForwardRef as ReactComponent };